var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrmDistroTitleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_16286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 7.49935C1.6665 4.74949 1.6665 3.37456 2.52078 2.52029C3.37505 1.66602 4.74998 1.66602 7.49984 1.66602H9.1665C11.9164 1.66602 13.2913 1.66602 14.1456 2.52029C14.9998 3.37456 14.9998 4.74949 14.9998 7.49935V9.16602C14.9998 11.9159 14.9998 13.2908 14.1456 14.1451C13.2913 14.9993 11.9164 14.9993 9.1665 14.9993H7.49984C4.74998 14.9993 3.37505 14.9993 2.52078 14.1451C1.6665 13.2908 1.6665 11.9159 1.6665 9.16602V7.49935Z",
    stroke: "url(#paint0_linear_50_16286)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1988 5.83398C16.3112 5.9018 17.0195 6.08788 17.5301 6.59847C18.3335 7.40184 18.3335 8.69485 18.3335 11.2809V12.8482C18.3335 15.4342 18.3335 16.7272 17.5301 17.5306C16.7268 18.334 15.4337 18.334 12.8477 18.334H11.2804C8.69436 18.334 7.40135 18.334 6.59798 17.5306C6.08739 17.02 5.90131 16.3117 5.8335 15.1993",
    stroke: "url(#paint1_linear_50_16286)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 10V5C9.35201 5.33333 9.50016 6.73333 10.8335 7M9.16683 10C9.16683 10.9205 8.42064 11.6667 7.50016 11.6667C6.57969 11.6667 5.8335 10.9205 5.8335 10C5.8335 9.07953 6.57969 8.33333 7.50016 8.33333C8.42064 8.33333 9.16683 9.07953 9.16683 10Z",
    stroke: "url(#paint2_linear_50_16286)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_16286",
    x1: 8.33317,
    y1: 1.66602,
    x2: 8.33317,
    y2: 14.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_16286",
    x1: 12.0835,
    y1: 5.83398,
    x2: 12.0835,
    y2: 18.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_50_16286",
    x1: 8.3335,
    y1: 5,
    x2: 8.3335,
    y2: 11.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_16286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrmDistroTitleIcon);
export default __webpack_public_path__ + "static/media/strm-distro-title-icon.fcd2a585af74e0210740c41b5840f143.svg";
export { ForwardRef as ReactComponent };